import { Listing } from "../../../../types/listings.types";

const getGratuityPercent = (listing: Listing) =>
  listing.full_service?.gratuity?.value ?? 0;

/** The symbol for `currency`, e.g. "$" for USD, for input prefixes. */
const getCurrencySymbol = (currency: string) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency })
    .formatToParts(0)
    .find((part) => part.type === "currency")?.value ?? currency;

type NumberFormatter = {
  formatNumber: (value: number, options: Intl.NumberFormatOptions) => string;
};

/** A whole-unit amount in `currency`, e.g. "$500". */
const formatCurrencyAmount = (
  intl: NumberFormatter,
  amount: number,
  currency: string,
) =>
  intl.formatNumber(amount, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

export { formatCurrencyAmount, getCurrencySymbol, getGratuityPercent };
